<template>
  <div class="item-tab">
    <div class="tabs">
      <div
        v-for="(item, i) in tab"
        :key="i"
        @click="navigate(i)"
        class="tabs-item"
        :class="{ tabact: i == index }"
      >
        {{ item }}
      </div>
      <div class="tabs-item seleapi">
        <a href="http://dqb-1688.com/ApiOpen/apitext/">点击查看API</a>
      </div>
    </div>
    <div class="content">
      <!-- 本体 -->
      <div class="noum" v-if="index == 0" style="padding: 15px 0">
        <div class="prop">
          <div
            class="props-wrap"
            v-for="(item, i) in data.content.props"
            :key="i"
          >
            <div class="prop-hd">
              {{ item.propName }}
              <!-- {{ item.propId }} -->
            </div>
            <ul class="prop-bd">
              <template v-for="(opt, j) in item.child">
                <li
                  class="prop-item"
                  :key="j"
                  v-if="opt.optName != 'null'"
                  :class="newcolor(opt.select)"
                  @click="newoptid(item.propId, opt.optId)"
                >
                  {{ opt.optName }}
                  <!-- {{opt.optId}} -->
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
      <!-- 附件 -->
      <div class="annex" v-if="index == 1" style="padding: 15px 0">
        <div
          class="comb-wrap"
          v-for="(item, i) in data.content.accData"
          :key="i"
        >
          <div class="comb-hd">
            {{ item.typeName }}
          </div>
          <ul class="comb-bd">
            <li
              class="comb-item"
              v-for="(tititem, j) in item.child"
              :key="j"
              :class="{ activewidth: id == tititem.ae }"
            >
              <div>
                <el-checkbox
                  v-model="tititem.selected"
                  :disabled="tititem.disabled"
                  @change="checkbox(tititem)"
                ></el-checkbox>
                <span
                  class="comb-item-label"
                  @click="optshow(tititem.ae, data.content)"
                  :class="{ activecolor: id == tititem.ae }"
                >
                  {{ tititem.name }}
                </span>
              </div>
              <transition name="el-zoom-in-top">
                <div class="comb-info" v-if="id == tititem.ae">
                  <div class="comb-product">
                    <div class="comb-img">
                      <el-image
                        style="width: 52px; height: 52px"
                        :src="img"
                        :preview-src-list="imgarr"
                      >
                      </el-image>
                    </div>
                    <div class="comb-title">
                      <div class="name">
                        {{ tititem.order }}
                      </div>
                      <div
                        class="p-ellipsis"
                        v-if="tititem.orderNum != '无订货号'"
                      >
                        <span class="p-detail-label">订货号:</span>
                        {{ tititem.orderNum }}
                      </div>
                      <div class="p-ellipsis">
                        <span class="priced"
                          >￥
                          {{ tititem.price == 0 ? "未定价" : tititem.price }}
                        </span>
                        <span class="price-before" v-if="tititem.price != 0"
                          >￥
                          {{ tititem.price }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="prop">
                    <div
                      class="props-wrap"
                      v-for="(titdata, k) in tititem.props"
                      :key="k"
                    >
                      <div class="prop-cd">
                        {{ titdata.propName }}
                        <!-- {{titdata.propId}} -->
                      </div>
                      <ul class="prop-bd">
                        <li
                          class="prop-item"
                          v-for="(optdata, z) in titdata.child"
                          :key="z"
                          :class="optselect(optdata.select)"
                          @click="
                            selectopt(tititem, titdata.propId, optdata.optId)
                          "
                        >
                          {{ optdata.optName }}
                          <!-- {{optdata.optId}} -->
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </transition>
            </li>
          </ul>
        </div>
        <div class="content" v-if="a.length == 0">暂无附件</div>
      </div>
      <!-- 明细 -->
      <div class="det" v-show="index == 2" style="padding: 15px 0">
        <div class="comb-hd">
          <el-row>
            <el-col :span="8" class="center">部件名称</el-col>
            <el-col :span="4">订货号</el-col>
            <el-col :span="4" class="right">表价</el-col>
            <el-col :span="4" class="right">折扣</el-col>
            <el-col :span="4" class="right">折后价</el-col>
          </el-row>
        </div>
        <div class="comb-bd">
          <div class="comb-item light">
            <template v-for="(item, i) in data.content.inventory">
              <el-row :key="i" v-if="item.main == true">
                <el-col :span="8">{{ item.name }}</el-col>
                <el-col :span="4">{{ item.order }}</el-col>
                <el-col :span="4" class="right">{{ item.price }}</el-col>
                <el-col :span="4" class="right">{{ spenum }}%</el-col>
                <el-col :span="4" class="right disprice">{{
                  item.price | disprice(spenum)
                }}</el-col>
              </el-row>
            </template>
          </div>
          <template v-for="(item, i) in data.content.inventory">
            <div class="comb-item" :key="i" v-if="item.main == false">
              <el-row>
                <el-col :span="8">{{ item.order }}</el-col>
                <el-col :span="4">{{ item.orderNum }}</el-col>
                <el-col :span="4" class="right">{{ item.price }}</el-col>
                <el-col :span="4" class="right">{{ accnum }}%</el-col>
                <el-col :span="4" class="right disprice">{{
                  item.price | disprice(accnum)
                }}</el-col>
              </el-row>
            </div>
          </template>
        </div>
      </div>
      <!-- 相似系列 -->
      <div class="enter" v-show="index == 3" style="padding: 15px 0">
        <div class="comb">
          <div class="comb-hd">
            <ul class="prop-bd">
              <li
                class="prop-item"
                :class="{ active: item.factID == factid }"
                v-for="(item, i) in factdata"
                :key="i"
                @click="alink(item.factID, sid)"
              >
                {{ item.factName }}
              </li>
            </ul>
          </div>
          <div class="comb-bd" v-if="sdata != ''">
            <div class="titbd">
              <div class="n1 name">系列</div>
              <div class="n1 name">厂家</div>
              <div class="n2 name">操作</div>
            </div>
            <el-row class="a" v-for="(propdata, j) in edata" :key="j">
              <el-col :span="10"
                ><div
                  class="center"
                  @click="handle(propdata.sid, propdata.fid, propdata.fname)"
                >
                  {{ propdata.sname }}
                </div></el-col
              >
              <el-col :span="10"
                ><div
                  class="center"
                  @click="handle(propdata.sid, propdata.fid, propdata.fname)"
                >
                  {{ propdata.fname }}
                </div></el-col
              >
              <el-col :span="4"
                ><div
                  class="center"
                  @click="handle(propdata.sid, propdata.fid, propdata.fname)"
                >
                  查看
                </div></el-col
              >
            </el-row>
          </div>
          <div class="comb-bd" v-if="sdata == ''">此品牌暂无相似系列</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

/* 1、导入方法 */
import { spedataAll, accdataAll, alike } from "../network/home";
import { jiami } from "../util/sign.js";

import { getsperdata } from "../util/getData.js";

export default {
  data() {
    return {
      tab: ["本体", "附件", "明细", "相似系列"],
      index: 0 /* 选项卡索引 */,
      img: "",
      imgarr: [],

      /* 本体相关数据 */
      a: {} /* 判断有无附件 */,
      data: {
        content: {},
        data: {
          spedata: {}, //本体数据
          accdata: {}, //附件数据

          defaultSelected: [], //默认选中
          ShortName: "", //名称
          acckey: [],
        },
      },
      defoptstr: [] /* 层级id和选项id */,

      /* 附件相关数据 */
      id: 0,
      accoptstr: [] /* 附件层级id和选项id */,
      item: [],

      /* 相似系列相关数据 */
      sdata: [],
      edata: [],
      factid: "",

      price: {},
    };
  },

  watch: {
    sid(newVal) {
      this.alldata(newVal);
      this.dex(); /* 系列变化时回到第一个选项卡 */
      this.alink(this.fid, newVal);
      this.check();
      this.id = 0;
    },
  },
  computed: {
    ...mapState([
      "fid",
      "sid",
      "shortname",
      "defaultselect",
      "spenum",
      "accnum",
    ]),
    factdata() {
      return this.$store.state.fdata;
    },
  },

  created() {
    this.alldata(this.sid);
    this.alink(this.fid, this.sid);
    this.imgsrc();
  },
  // mounted() {
  //   this.alink(this.fid, this.sid);
  // },

  updated() {
    this.disallprice();
  },

  methods: {
    /* 选项卡操作 */
    navigate(i) {
      this.index = i;
    },
    dex() {
      this.index = 0;
    },
    imgsrc() {
      this.img = "http://dqb-1688.com/image/" + 0 + ".jpg";
      this.imgarr = ["http://dqb-1688.com/image/" + 0 + ".jpg"];
    },

    /* 请求接口获取数据 */
    alldata(id) {
      spedataAll(jiami(id)).then((res) => {
        res = this.deStr(res);
        this.data.data.spedata = res.data;
        // console.log(res);
        this.defid(res.data);
        accdataAll(jiami(id)).then((res) => {
          res = this.deStracc(res);
          // console.log(res.data);
          this.data.data.accdata = res.data;
          this.data.data.defaultSelected = this.defaultselect;
          this.data.data.ShortName = this.shortname;
          let data = getsperdata(this.data.data);
          this.data.content = data;
          this.a = data.accData;
          // console.log(data);
          this.$store.commit("content", data);
          this.getaccopt(data);
          this.allprice(data).toString();
          this.allname(data);
        });
      });
    },

    de(compressed) {
      var i,
        dictionary = [],
        w,
        result,
        k,
        entry = "",
        dictSize = 256;
      for (i = 0; i < 256; i += 1) {
        dictionary[i] = String.fromCharCode(i);
      }
      w = String.fromCharCode(compressed[0]);
      result = w;
      for (i = 1; i < compressed.length; i += 1) {
        k = compressed[i];
        if (dictionary[k]) {
          entry = dictionary[k];
        } else {
          if (k === dictSize) {
            entry = w + w.charAt(0);
          } else {
            return null;
          }
        }

        result += entry;
        dictionary[dictSize++] = w + entry.charAt(0);
        w = entry;
      }
      return result;
    },

    deStr(dataStr) {
      let comp = [];
      for (let i = 0; i < dataStr.length; i += 2) {
        comp.push(
          (dataStr[i].charCodeAt() - 903) * 500 +
            dataStr[i + 1].charCodeAt() -
            903
        );
      }
      return JSON.parse(this.de(comp));
    },

    deStracc(dataStr) {
      let comp = [];
      for (let i = 0; i < dataStr.length; i += 2) {
        comp.push(
          (dataStr[i].charCodeAt() - 809) * 550 +
            dataStr[i + 1].charCodeAt() -
            809
        );
      }
      return JSON.parse(this.de(comp));
    },

    /* A、本体逻辑 */
    /* 获取默认选中选项 */
    defid(res) {
      let pid = "",
        tid = "";
      this.defoptstr = [];
      for (let i = 0; i < res.spe_prop.length; i++) {
        this.defoptstr.push({
          tid: res.spe_prop[i].propId,
          pid: res.spe_prop[i].defaultSelected,
        });
      }
    },

    /* 判断选中选项 */
    newcolor(select) {
      if (select) {
        return "activenoum";
      }
    },

    /* 选项动态变化时 */
    newoptid(tid, pid) {
      let arr = [];
      for (let i = 0; i < this.defoptstr.length; i++) {
        if (this.defoptstr[i].tid == tid) {
          this.defoptstr[i].pid = pid;
        }
        arr.push(this.defoptstr[i].pid);
      }
      this.data.data.defaultSelected = arr;
      let data = getsperdata(this.data.data);
      this.data.content = data;
      this.a = data.accData;
      console.log(data);
      this.$store.commit("content", data);
      this.allprice(data).toString();
      this.allname(data);
    },

    /* B、附件逻辑 */
    /* 显示隐藏附件详情数据 */
    optshow(aid, item) {
      if (aid != this.id) {
        this.id = aid;
      } else {
        this.id = 0;
      }
      this.getaccopt(item);
    },

    /* 判断选中选项 */
    optselect(select) {
      if (select) {
        return "activeannex";
      }
    },

    getaccopt(list) {
      this.accoptstr = [];
      for (let i = 0; i < list.accData.length; i++) {
        for (let j = 0; j < list.accData[i].child.length; j++) {
          for (let k = 0; k < list.accData[i].child[j].props.length; k++) {
            for (
              let z = 0;
              z < list.accData[i].child[j].props[k].child.length;
              z++
            ) {
              if (list.accData[i].child[j].props[k].child[z].select) {
                let obj = {
                  ae: "",
                  ck: 0,
                  pid: "",
                  tid: "",
                };
                if (list.accData[i].child[j].selected) {
                  obj.ck = 1;
                }
                obj.ae = list.accData[i].child[j].ae;
                obj.pid = list.accData[i].child[j].props[k].propId;
                obj.tid = list.accData[i].child[j].props[k].child[z].optId;

                this.accoptstr.push(obj);
              }
            }
          }
        }
      }
    },

    /* 附件选项点击时 */
    selectopt(item, pid, sid) {
      for (let i = 0; i < this.accoptstr.length; i++) {
        if (this.accoptstr[i].ae == item.ae && this.accoptstr[i].pid == pid) {
          this.accoptstr[i].tid = sid;
        }
      }
      let key = this.ret(this.accoptstr);
      console.log(this.accoptstr);
      console.log(key);
      this.data.data.acckey = key;
      let data = getsperdata(this.data.data);
      this.data.content = data;
      console.log(data);
      this.getaccopt(data);
      this.allprice(data).toString();
      this.allname(data);
      // console.log(data);
      this.$store.commit("content", data);
    },

    //处理附件所有选中关系
    ret(arr) {
      let arred = [];
      let res = [];
      let json = {};
      for (let i = 0; i < arr.length; i++) {
        if (!json[arr[i].ae]) {
          res.push(arr[i]);
          json[arr[i].ae] = 1;
        }
      }

      for (let j = 0; j < res.length; j++) {
        let arr1 = [];
        for (let i = 0; i < arr.length; i++) {
          if (res[j].ae == arr[i].ae) {
            arr1.push(arr[i].tid);
          }
        }
        let obj = {
          ae: null,
          ck: 0,
          select: null,
        };

        obj.ae = res[j].ae;
        obj.ck = res[j].ck;

        obj.select = arr1;
        arred.push(obj);
      }
      return arred;
    },

    /* 获取总价格 */
    allprice(data) {
      let sumprice = 0;
      sumprice += parseFloat(data.propPrice);
      if (data.accData.length != 0) {
        for (let i = 0; i < data.accData.length; i++) {
          for (let j = 0; j < data.accData[i].child.length; j++) {
            if (data.accData[i].child[j].selected) {
              sumprice += parseFloat(data.accData[i].child[j].price);
            }
          }
        }
      }
      // console.log(sumprice.toFixed(2).toString());
      /* 把价格存入vuex */
      this.$store.commit("sumprice", sumprice.toFixed(2).toString());
      return sumprice.toFixed(2);
    },

    allname(data) {
      // console.log(data);
      let name = "";
      name += data.propName;
      if (data.accData.length != 0) {
        for (let i = 0; i < data.accData.length; i++) {
          for (let j = 0; j < data.accData[i].child.length; j++) {
            if (data.accData[i].child[j].selected) {
              if (data.accData[i].child[j].name2 != "") {
                name += data.accData[i].child[j].name2;
              }
            }
          }
        }
      }
      /* 把总名称存入vuex */
      this.$store.commit("allname", name);
    },

    /* 附件勾选 */
    checkbox(item) {
      this.item = item;
      let arr = [];
      arr = this.ret(this.accoptstr);
      if (item.selected) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].ae == item.ae) {
            arr[i].ck = 1;
          }
        }
        this.data.data.acckey = arr;
        let data = getsperdata(this.data.data);
        this.data.content = data;
        this.$store.commit("content", data);
        this.allprice(data).toString();
        this.getaccopt(data);
        this.allname(data);
      } else {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].ae == item.ae) {
            arr[i].ck = 0;
          }
        }
        this.data.data.acckey = arr;
        let data = getsperdata(this.data.data);
        this.data.content = data;
        this.$store.commit("content", data);
        this.allprice(data).toString();
        this.getaccopt(data);
        this.allname(data);
      }
    },

    check() {
      let arr = [];
      arr = this.ret(this.accoptstr);
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].ae == this.item.ae) {
          arr[i].ck = 0;
        }
      }
      this.data.data.acckey = arr;
      let data = getsperdata(this.data.data);
      this.data.content = data;
      this.$store.commit("content", data);
      this.allprice(data).toString();
      this.getaccopt(data);
      this.allname(data);
    },

    /* C、相似系列逻辑 */
    /* 请求数据接口 */
    alink(fid, sid) {
      this.factid = fid;
      alike(fid, sid).then((res) => {
        this.sdata = res;
        this.edata = [];
        if (res.length > 0) {
          for (let i = 0; i < res.length; i++) {
            for (let j = 0; j < this.factdata.length; j++) {
              if (res[0].FactId == this.factdata[j].factID) {
                this.edata.push({
                  sname: res[i].SeriesName,
                  fname: this.factdata[j].factName,
                  sid: res[i].SeriesId,
                  fid: res[i].FactId,
                });
              }
            }
          }
        }
      });
    },

    handle(sid, fid, fname) {
      this.$store.commit("fid", fid); /* 把品牌 id存入vuex */
      this.$store.commit("sid", sid); /* 把系列 id存入vuex */
      this.$store.commit("fname", fname); /* 把品牌名存入vuex */
    },
    /* 获取折扣后的总价格 */
    disallprice() {
      let p = document.getElementsByClassName("disprice");
      let a = 0;
      for (let i = 0; i < p.length; i++) {
        a = a + parseFloat(p[i].innerText);
      }
      // console.log(a.toFixed(2));
      this.$store.commit("disprice", a.toFixed(2));
    },
  },

  /* 过滤 */
  filters: {
    /* 折扣后的价格 */
    disprice(value, discount) {
      return ((value * discount) / 100).toFixed(2);
    },
  },
};
</script>

<style scoped lang="less">
@import "../assets/less/tab";
</style>

<style scoped lang="less">
@import "../assets/less/noum";
</style>

<style scoped lang="less">
@import "../assets/less/annex";
</style>

<style scoped lang="less">
@import "../assets/less/det";
</style>

<style scoped lang="less">
@import "../assets/less/enter";
</style>
